import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { membershipReactivationErrorSelector } from '@hero/redux-data/backoffice/membershipReactivation/selectors';
import { useNotifications } from '../../context/notification';
const useMembershipReactivateFailAlert = () => {
    const { error, errorMessage } = useSelector(membershipReactivationErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: errorMessage || 'Error reactivating membership.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error, errorMessage]);
};
export default useMembershipReactivateFailAlert;
